import React from "react";
import { TopBar } from "@/components/TopBar";
import PriceListPanel from "@/components/PriceListPanel";

// Owner 2026-10-10/11: the front desk's Price List page (menu Transaksi > Price List).
export default function PriceList() {
  return (
    <div data-testid="price-list-page" className="min-h-screen bg-slate-950 text-slate-200">
      <TopBar />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-5">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-100">Price List</h1>
          <p className="text-sm text-slate-400 mt-1">Harga barang aktif per tipe customer. Hanya untuk dilihat — harga dihitung ulang oleh server saat transaksi.</p>
        </div>
        <PriceListPanel />
      </main>
    </div>
  );
}
